import { network } from '@utils'
import type { QueryClient } from '@tanstack/react-query'
import { QueryFunction } from '../root.ts'

export enum FirstTransactionFetchNotice {
  Idle = 'idle',
  Fetching = 'fetching',
  Delayed = 'delayed'
}

interface FirstTransactionFetchProps {
  slug: string
}

export interface IFirstTransactionFetch {
  notice: FirstTransactionFetchNotice
}

/** Cached while idle so repeat Document page visits do not refetch until invalidated. */
export const FIRST_TRANSACTION_FETCH_STALE_MS = 1000 * 60 * 60 * 24

export const firstTransactionFetchQueryKey = (slug: string) =>
  [slug, 'integrations', 'banking', 'first_transaction_fetch'] as const

export const invalidateFirstTransactionFetchNotice = (queryClient: QueryClient, slug: string) =>
  queryClient.invalidateQueries({ queryKey: firstTransactionFetchQueryKey(slug) })

export const fetchFirstTransactionFetchNotice: QueryFunction<
  FirstTransactionFetchProps,
  IFirstTransactionFetch
> = async ({ slug }) => {
  const url = `/v1/integrations/banking/${slug}/first_transaction_fetch/`
  const { data } = await network.httpClient.request({
    url,
    method: 'GET'
  })
  return data
}
